export const domain = 'Dialog';

// action types
export const SHOW_DIALOG = `${domain}/SHOW_DIALOG`;
export const CLOSE_DIALOG = `${domain}/CLOSE_DIALOG`;
